export default {
  potentialCustomer: 'Potential customer',
  frequentVisitor: 'Frequent visitor',
  arrivalStore: 'Arrival store',
  arrivalStoreWithColon: 'Arrival store:',
  remindersForPotentialCustomer: 'Reminders for potential customer',
  remindersForFrequentVisitor: 'Reminders for regular customer',
  YearsOld: '{num} {year} old',
  arrivalTime: 'Arrival time',
  arrivalTimeWithColon: 'Arrival time:',
  customerTag: 'Customer tag',
  memberTag: 'Member tag',
  recentConsumption: 'Recent consumption',
  recentConsumptionWithColon: 'Recent consumption:',
  customerArrivalReminder: 'Customer arrival reminder',
  yuan: '￥',
  week: ' Week ',
  comma: ',',
  timeActuallyTook: '      time actually took ',
  d: '{d}d ',
  h: '{h}h ',
  m: '{m}m',
  underOneM: '<1m',
  noInstallationPackageToDownloadPleaseContactAdministrator: 'No installation package to download, please contact administrator.',
  Confirm: 'Confirm'
}
